import React from 'react';
import {_GPY} from '../env.js'

class Unknowni18nKeys extends React.Component {
  constructor(props) {
   super(props);
   this.state = {
   };
  }

  componentDidMount(){
  }

	render() {
    return (
      <div>
        <div className="row">
          <div className="col-12">
          <span >
           {_GPY.i18n.unknownKeys.map((key,idx)=>
               <p><code> INSERT INTO `GPY_I18N` (`id`, `keyName`, `lang`, `val`) VALUES (NULL, '{key}', 'en', 'TEXT');</code></p>
            )}
          </span>
          </div>
        </div>
      </div>
		 	);
    }
}
export default Unknowni18nKeys;
